var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClosePanelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Final-Designs",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.74393641,6.20690665 L0.302999969,1.76601331 C-0.100999996,1.36201333 -0.100999989,0.706999957 0.302999984,0.302999984 C0.706999957,-0.100999989 1.36201333,-0.100999996 1.76601331,0.302999969 L6.20690665,4.74393641 L6.20690665,6.20690665 L4.74393641,6.20690665 Z M19.697,18.2339867 L15.2560636,13.7930933 L13.7930933,13.7930933 L13.7930933,15.2560636 L18.2339867,19.697 C18.6379867,20.101 19.293,20.101 19.697,19.697 C20.101,19.293 20.101,18.6379867 19.697,18.2339867 Z M8.96551999,7.93103999 L8.96551999,2.41381331 C8.96551999,1.84248578 8.50236752,1.37933331 7.93103999,1.37933331 C7.35971246,1.37933331 6.89655999,1.84248578 6.89655999,2.41381331 L6.89655999,6.89655999 L2.41381331,6.89655999 C1.84248578,6.89655999 1.37933331,7.35971246 1.37933331,7.93103999 C1.37933331,8.50236752 1.84248578,8.96551999 2.41381331,8.96551999 L7.93103999,8.96551999 C8.50236752,8.96551999 8.96551999,8.50236752 8.96551999,7.93103999 Z M13.10344,17.5861867 L13.10344,13.10344 L17.5861867,13.10344 C18.1575142,13.10344 18.6206667,12.6402875 18.6206667,12.06896 C18.6206667,11.4976325 18.1575142,11.03448 17.5861867,11.03448 L12.06896,11.03448 C11.4976325,11.03448 11.03448,11.4976325 11.03448,12.06896 L11.03448,17.5861867 C11.03448,18.1575142 11.4976325,18.6206667 12.06896,18.6206667 C12.6402875,18.6206667 13.10344,18.1575142 13.10344,17.5861867 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosePanelIcon);
export default __webpack_public_path__ + "static/media/close-panel-icon.a9790ce1067ffadc773588e3b2802b06.svg";
export { ForwardRef as ReactComponent };